const apiBase =
    import.meta.env.VITE_API_BASE_URL || "https://dev-orders.turnmeroyal.com/";

export default {
    base_url: apiBase,
};
